<template>
  <div class="tab-main">
    <swiper
      :options="{
        slidesPerView: 'auto',
        freeMode: true,
        initialSlide: 0,
      }"
      class="swiper"
    >
      <swiper-slide :class="{ active: $route.query.category == '0' }">
        <div
          @click="
            $router
              .push({ name: 'CustomerList', query: { category: '0' } })
              .catch(() => {})
          "       
        >
          전체
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: $route.query.category == '1' }">
        <div
          @click="
            $router
              .push({ name: 'CustomerList', query: { category: '1' } })
              .catch(() => {})
          "
        >
          공지
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: $route.query.category == '2' }">
        <div
          @click="
            $router
              .push({ name: 'CustomerList', query: { category: '2' } })
              .catch(() => {})
          "
        >
          A/S
        </div>
      </swiper-slide>

      <swiper-slide :class="{ active: $route.query.category == '3' }">
        <div
          @click="
            $router
              .push({ name: 'CustomerList', query: { category: '3' } })
              .catch(() => {})
          "
        >
          제안
        </div>
      </swiper-slide>
    </swiper>
    <ul class="nav nav-pills" id="pills-tab" role="tablist">
      <li class="nav-item col-1" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-1-tab"
          type="button"
          @click="
            $router
              .push({ name: 'CustomerList', query: { category: '0' } })
              .catch(() => {})
          "
          :class="{ active: $route.query.category == '0' }"
        >
          전체
        </button>
      </li>
      <li class="nav-item col-1" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-2-tab"
          type="button"
          @click="
            $router
              .push({ name: 'CustomerList', query: { category: '1' } })
              .catch(() => {})
          "
          :class="{ active: $route.query.category == '1' }"
        >
          공지사항
        </button>
      </li>
      <li class="nav-item col-1" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-3-tab"
          type="button"
          @click="
            $router
              .push({ name: 'CustomerList', query: { category: '2' } })
              .catch(() => {})
          "
          :class="{ active: $route.query.category == '2' }"
        >
          A/S
        </button>
      </li>
      <li class="nav-item col-1" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-3-tab"
          type="button"
          @click="
            $router
              .push({ name: 'CustomerList', query: { category: '3' } })
              .catch(() => {})
          "
          :class="{ active: $route.query.category == '3' }"
        >
          제안
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  name: "Tab",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      tab: 1,
      /*swiperOptions: {
        slidesPerView: 'auto',
        freeMode: true
      }*/
    };
  },
  computed: {},
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
};
</script>
